import * as yup from "yup"

export const registerSchema = yup.object().shape({
    name: yup.string().required("este campo é obrigatorio"),
    email: yup
    .string()
    .required('este campo é obrigatorio')
    .email('digite um e-mail valido!'),
    password: yup
    .string()
    .required('este campo é obrigatorio')
    .matches(/[A-Z]/, 'deve conter ao menos 1 letra maiúscula')
    .matches(/[a-z]/, 'deve conter ao menos 1 letra minuscula')
    .matches(/(\d)/, 'deve conter ao menos um número')
    .matches(/(\W)|_/, 'deve conter um caracter especial')
    .matches(/.{8,}/, 'deve ter no minimo 8 digitos'),
    confirmPassword: yup
    .string()
    .oneOf(
      [yup.ref('password')],
      'as senhas devem ser iguais!'
    ),
    bio: yup
    .string()
    .required('este campo é obrigatorio'),
    contact: yup
    .string()
    .required('este campo é obrigatorio'),
})